import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react'; 
import BoxCard from './BoxCard';
import VRNBox from './VRNBox';
import '../css/Managehssestyle.css'
//import '../css/customBootstrapExtended.css'
class VehicleGroupBoxItem extends React.Component {
    constructor(props) {
        super(props);

        

    }
    render() {
        return ( 
               <Card className="card-content collapse show">
                     <Card.Body>
                     <div className="accordion" id="accordionExample">
                                      <div className="collapse-margin-hsseone">
                                        <div
                                          className="card-header"
                                          id="headingEleven"
                                          data-toggle="collapse"
                                          role="button"
                                          data-target={"#" + this.props.Title}
                                          aria-expanded="false"
                                          aria-controls="collapseEleven"
                                        >
                                           <div className="col-sm-12">
                                            <span className="lead collapse-title">
                                              <fieldset>
                                                <div className="vs-radio-con vs-radio-warning">
                                                  <input
                                                    type="radio"
                                                    name="radiocolor"
                                                    defaultValue="false"
                                                  />
                                                  <span className="vs-radio">
                                                    <span className="vs-radio--border" />
                                                    <span className="vs-radio--circle" />
                                                  </span>
                                                  <span className>{this.props.Title}</span>
                                                </div>
                                              </fieldset>
                                            </span>
                                          </div>

                                        </div>
                                        <div
                                          id={this.props.Title}
                                          className="collapse"
                                          aria-labelledby="headingOne"
                                          data-parent="#accordionExample"
                                        >  
                                           
                                           <BoxCard divText="7002 0007 1234 5678"/>
                                           <BoxCard divText="7002 0007 1234 5678"/>
                                           <BoxCard divText="7002 0007 1234 5678"/>

                                          
 
                                        </div>
                                     </div>
                    </div>
                     </Card.Body>
               </Card>
            
            );

        }
        
}
        
        
export default VehicleGroupBoxItem;